module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "game-header"
  }, [_c('div', {
    staticClass: "backarrowDiv",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-game",
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1), _vm._v(" "), (_vm.trigger) ? _c('div', {
    staticClass: "game-titles"
  }, [(_vm.currentData) ? _c('h2', [_vm._v("\n        " + _vm._s(_vm.currentData.courseName) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.currentData) ? _c('h6', [_vm._v("\n        " + _vm._s(_vm.currentData ? _vm.currentData.name : _vm.$t("game-new.game-header.game")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('h6', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "eng-progress-container"
  }, [_c('div', {
    staticClass: "eng-progress-bar",
    attrs: {
      "id": "eng-progress-bar"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f9a78c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game-new/game-header.vue
// module id = 405
// module chunks = 1 2